export default __webpack_public_path__ + "static/media/icone-ecommerce.2a1c6b12.svg";